import React, { useState } from 'react'
import PerfectScrollbar from 'react-perfect-scrollbar'
import {
  ExternalLink as ExternalLinkIcon,
  Trash2 as Trash2Icon,
  Send as SendIcon,
} from 'react-feather'
import PropTypes from 'prop-types'
import { Box, Button } from '@material-ui/core'

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from 'components/Table'
import { MenuButton } from 'components'

import RecipeDialog from '../ReciptDialog'

import helpers from 'helpers'

import useSnackbar from 'hooks/useSnackbar'
import constants from 'constants/index'
import useStyles from './styles'
import * as service from 'service'

const ApprovalTable = ({ privacyApprovals, isLoading, onDelete }) => {
  const classes = useStyles()
  const {
    PERSON_APPROVAL_OPTIONS,
    APPROVED_PERSON_STATUS_ID,
    AWANTING_APPROVAL_PERSON_STATUS_ID,
  } = constants.documents

  const [openDialog, setOpenDialog] = useState(false)
  const [selectedApproval, setSelectedApproval] = useState(null)

  const snackbar = useSnackbar()

  const getStatusLabel = (status) =>
    PERSON_APPROVAL_OPTIONS.find((option) => option.id === String(status))
      ?.name ?? status

  const handleOpenDialog = (approval) => {
    setSelectedApproval(approval)
    setOpenDialog(true)
  }

  const handleResendEmail = async (approval) => {
    try {
      await service.dponet.privacyPolicies.sendLink({
        privacyPolicyId: approval.privacyPolicyId,
        email: [approval.email],
      })

      snackbar.open({
        message: 'E-mail enviado com sucesso!',
        variant: 'success',
      })
    } catch (error) {
      console.error(error)
      snackbar.open({
        message: helpers.formatters.errorMessage(error),
        variant: 'error',
      })
    }
  }

  const handleDelete = async (approval) => {
    try {
      await service.dponet.privacyPolicies.destroyPrivacyApproval({
        privacyPolicyId: approval.privacyPolicyId,
        privacyPolicyApprovalId: approval.id,
      })

      snackbar.open({
        message: 'Aprovação removida com sucesso!',
        variant: 'success',
      })
      if (onDelete) onDelete()
    } catch (error) {
      console.error(error)
      snackbar.open({
        message: helpers.formatters.errorMessage(error),
        variant: 'error',
      })
    }
  }

  return (
    <Box width="100%">
      <PerfectScrollbar
        options={{ wheelPropagation: false, useBothWheelAxes: true }}
      >
        <Table
          emptyMessage="Nenhum registro de aprovação encontrado"
          isLoading={isLoading}
          size="small"
        >
          <TableHead>
            <TableRow>
              <TableCell
                align="left"
                width="30%"
                className={classes.initialContent}
              >
                Nome
              </TableCell>
              <TableCell
                align="left"
                width="40%"
                className={classes.finalContent}
              >
                E-mail
              </TableCell>
              <TableCell
                align="center"
                width="15%"
                className={classes.finalContent}
              >
                Status
              </TableCell>
              <TableCell
                align="center"
                width="15%"
                className={classes.finalContent}
              >
                Versão
              </TableCell>
              <TableCell
                align="center"
                width="15%"
                className={classes.finalContent}
              >
                Ações
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {privacyApprovals.map((approval, index) => (
              <TableRow key={approval.id + index}>
                <TableCell
                  align="left"
                  width="30%"
                  className={classes.initialContent}
                >
                  {approval.userName || approval.nameConfirmation || '-'}
                </TableCell>
                <TableCell
                  align="left"
                  width="40%"
                  className={classes.finalContent}
                >
                  {approval.email}
                </TableCell>
                <TableCell
                  align="center"
                  width="15%"
                  className={classes.finalContent}
                >
                  {getStatusLabel(approval.status)}
                </TableCell>
                <TableCell
                  align="center"
                  width="15%"
                  className={classes.finalContent}
                >
                  {approval.documentVersionNumber ?? '-'}
                </TableCell>
                <TableCell
                  align="center"
                  width="15%"
                  className={classes.finalContent}
                >
                  <MenuButton>
                    {String(approval.status) === APPROVED_PERSON_STATUS_ID && (
                      <Button
                        size="small"
                        color="secondary"
                        fullWidth
                        startIcon={
                          <ExternalLinkIcon size={16} strokeWidth={2.5} />
                        }
                        onClick={() => handleOpenDialog(approval)}
                      >
                        Ver recibo
                      </Button>
                    )}
                    {String(approval.status) ===
                      AWANTING_APPROVAL_PERSON_STATUS_ID && (
                      <Button
                        size="small"
                        color="secondary"
                        fullWidth
                        startIcon={<SendIcon size={16} strokeWidth={2.5} />}
                        onClick={() => handleResendEmail(approval)}
                      >
                        Reenviar e-mail
                      </Button>
                    )}
                    {String(approval.status) ===
                      AWANTING_APPROVAL_PERSON_STATUS_ID && (
                      <Button
                        size="small"
                        color="secondary"
                        fullWidth
                        startIcon={<Trash2Icon size={16} strokeWidth={2.5} />}
                        onClick={() => handleDelete(approval)}
                      >
                        Remover aprovação
                      </Button>
                    )}
                  </MenuButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </PerfectScrollbar>
      <RecipeDialog
        open={openDialog}
        setOpen={setOpenDialog}
        approval={selectedApproval}
      />
    </Box>
  )
}

ApprovalTable.propTypes = {
  privacyApprovals: PropTypes.arrayOf(PropTypes.object),
  isLoading: PropTypes.bool,
  onDelete: PropTypes.func,
}

export default ApprovalTable
